import React from "react";
import ReactDOM from "react-dom";

import { BrowserRouter } from "react-router-dom";
import { Amplify } from "aws-amplify";
import { GuardProvider } from "react-router-guards";
import { LucralizeProvider } from "./main/contexts";
import Routes from "./presentation/components/routes";
import { GlobalStyle } from "./presentation/styles/global";
import "bootstrap/dist/css/bootstrap.min.css";
import awsconfig from "./main/configs/aws-exports.js";

import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "react-toastify/dist/ReactToastify.css";
import AlertBoxProvider from "./contexts/alert-box/alert_box";
import { AuthProviderGlobal } from "./contexts/auth-context/auth-context";
import DialogProvider from "./contexts/dialog-context/dialog";
import { MenuProvider } from "./contexts/menu";

import { addLanguage } from "./presentation/adapters/translate/translate";

Amplify.configure(awsconfig);

addLanguage("pt_BR");

ReactDOM.render(
  <LucralizeProvider>
    <BrowserRouter>
      <GlobalStyle />

      <GuardProvider>
        <AuthProviderGlobal>
          <MenuProvider>
            <DialogProvider>
              <AlertBoxProvider>
                <Routes />
              </AlertBoxProvider>
            </DialogProvider>
          </MenuProvider>
        </AuthProviderGlobal>
      </GuardProvider>
    </BrowserRouter>
  </LucralizeProvider>,
  document.getElementById("root"),
);
